import React from 'react';
import { Slidebar } from '@philips-internal/oswald-ui-components';
import { Placement, ThemeTonalRange } from '@philips-internal/oswald-ui-constants';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { noop } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as CancelIcon } from '../../../../../resources/assets/cancel-md-dark.svg';
import { foundationContext } from '../../../../index.js';
import { ExternalContent, LogoutLink } from './index.js';
function MobileMenu(props) {
    const { applicationTitle = 'application.name', handleVisibility, logoutExpression, showMobileMenu, showSubMenuHeader = false, } = props;
    const fragment = foundationContext.getMenuFragment();
    const renderCustomSlidebarHeader = () => {
        return (React.createElement("div", { className: "c-spotlight__custom-menu-header" },
            React.createElement("div", { className: "c-user-menu__title" }, MessageService.translate(applicationTitle)),
            React.createElement("div", { className: "c-spotlight__custom-menu-header__icon" },
                React.createElement(CancelIcon, { className: "c-application-bar__icon c-application-bar__nav", onClick: noop }))));
    };
    if (!showMobileMenu || !fragment) {
        return null;
    }
    return (React.createElement(Slidebar, { className: "c-spotlight__custom-menu-slidebar", hideHeader: !showSubMenuHeader, onClose: handleVisibility, open: showMobileMenu, placement: Placement.LEFT, showCloseButton: false, theme: ThemeTonalRange.BRIGHT, uuid: "spotlight-slider-uuid" },
        renderCustomSlidebarHeader(),
        React.createElement("div", { className: "c-spotlight__custom-menu-content" },
            React.createElement(ExternalContent, null),
            React.createElement(LogoutLink, { logoutExpression: logoutExpression }))));
}
export { MobileMenu, };
//# sourceMappingURL=mobile-menu.js.map